import { Entitlement, Status } from "@blacknut/javascript-sdk/dist";
import { StorageKey } from "core/services";

export const isTryBuy = (entitlement: Entitlement | undefined) =>
  isBlkTryBuy(entitlement) || isLGTryBuy(entitlement);

export const isBlkTryBuy = (entitlement: Entitlement | undefined) =>
  entitlement?.subscription?.organizationName.toLowerCase() === "blacknut" &&
  entitlement?.subscription?.tryBuy &&
  entitlement?.subscription?.status === Status.TRIALING;

export const isLGTryBuy = (entitlement: Entitlement | undefined) =>
  entitlement?.subscription?.organizationName.toLowerCase() === "lg" &&
  entitlement?.subscription?.tryBuy &&
  entitlement?.subscription?.status === Status.TRIALING &&
  !!localStorage.getItem(StorageKey.FEAT_WEBOS10YRS);
